import { createRouter, createWebHistory } from 'vue-router'
import auth from '@/middleware/auth'
import autoLogin from '@/middleware/autoLogin'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/auth',
      name: 'auth',
      component: () => import('../views/AuthView.vue'),
      beforeEnter: [autoLogin],
      redirect: { name: 'login_phone' },
      children: [
        {
          path: 'login',
          name: 'login',
          redirect: { name: 'login_phone' }
        },
        {
          path: 'login_phone',
          name: 'login_phone',
          component: () => import('@components/Auth/SignInPhone.vue')
        },
        {
          path: 'login_email',
          name: 'login_email',
          component: () => import('@components/Auth/SignInEmail.vue')
        },
        {
          path: 'pin',
          name: 'pin',
          component: () => import('../components/Auth/Pin.vue')
        },
        {
          path: 'link_email',
          name: 'link_email',
          component: () => import('@components/Auth/LinkEmail.vue')
        },
        {
          path: 'confirm_email',
          name: 'confirm_email',
          component: () => import('@components/Auth/ConfirmEmailPin.vue')
        },
        {
          path: 'registration',
          name: 'registration',
          component: () => import('../components/Auth/Registration.vue')
        },
        {
          path: 'password',
          name: 'password',
          component: () => import('../components/Auth/Password.vue')
        },
        {
          path: 'create_password',
          name: 'create_password',
          component: () => import('../components/Auth/CreatePassword.vue')
        },
        {
          path: 'recovery',
          name: 'recovery',
          component: () => import('../components/Auth/Recovery.vue')
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/SearchView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: () => import('../views/NotFoundView.vue')
    },
    {
      path: '/digital_bank',
      name: 'digital_bank',
      component: () => import('../views/DigitalBankView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/card_market',
      name: 'card_market',
      component: () => import('../views/CardMarketView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/personal_info/:id',
      name: 'personal_info',
      component: () => import('../views/PersonalInfoView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/add_contact',
      name: 'add_contact',
      component: () => import('../views/AddContactView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/create_contact',
      name: 'create_contact',
      component: () => import('../views/CreateContactView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/contact/:id',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('../views/UserView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: () => import('../views/CalculatorView.vue'),
      beforeEnter: [auth]
    },
    {
      path: '/cabinet',
      name: 'cabinet',
      component: () => import('../views/CabinetView.vue'),
      beforeEnter: [auth],
      redirect: { name: 'profile' },
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: () => import('../components/Cabinet/ProfileView.vue')
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('../components/Cabinet/SettingsView.vue')
        },
        {
          path: 'referral',
          name: 'referral',
          component: () => import('../components/Cabinet/ReferralView.vue')
        }
      ]
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('../views/SupportView.vue'),
      beforeEnter: [auth]
    }
  ]
})

export default router
